import React from "react";
import { Link } from "gatsby";
import styled from "styled-components";
import { theme } from "../styles/theme";
import { StaticImage } from "gatsby-plugin-image";
import Container from "../styles/Container";

const PromoSection = styled.section`
  margin: 22rem 0;
`;
const PromoGrid = styled.div`
  display: grid;
  @media ${theme.devices.lg} {
    grid-template-columns: 65% 1fr;
    gap: 3rem;
  }
`;
const PromoWash = styled.div`
  background: var(--lightgrey);
  margin-bottom: 3rem;

  @media ${theme.devices.md} {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    margin-bottom: 0;
  }

  .wash {
    border-bottom-left-radius: 0.7rem;
    border-bottom-right-radius: 0.7rem;

    @media ${theme.devices.md} {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0.7rem;
      border-top-right-radius: 0.7rem;
    }
  }
`;

const WashText = styled.div`
  padding: 4rem;
  display: flex;
  flex-direction: column;
  justify-content: center;

  h1 {
    font-size: 6rem;
    margin-bottom: 1rem;
  }
  h2 {
    color: var(--lightblue);
  }
`;

const PromoTech = styled.div`
  background: var(--lightgrey);
  display: grid;
  margin-top: 2rem;
  /* grid-template-rows: 1fr 1fr; */

  @media ${theme.devices.md} {
    margin-top: 0;
  }
  .tech {
    border-bottom-left-radius: 0.7rem;
    border-bottom-right-radius: 0.7rem;
  }
`;

const TechText = styled.div`
  padding: 4rem;

  display: flex;
  flex-direction: column;
  justify-content: center;

  h2 {
    font-size: 4rem;
    margin: 0;
    padding: 0;
  }

  .techtitle {
    margin-bottom: 2rem;
  }

  .phone {
    color: var(--lightblue);
  }
`;

const ContactUs = styled(Link)`
  padding: 1.5rem 2.5rem;
  background: var(--lightblue);
  color: white;
  font-family: Roboto;
  font-size: 1.8rem;
  font-weight: 600;
  letter-spacing: 0.2rem;
  width: 40%;
  text-align: center;
`;
export default function Promo() {
  return (
    <PromoSection>
      <Container>
        <PromoGrid>
          <PromoWash>
            <StaticImage src="../assets/images/wash.jpg" className="wash" />
            <WashText>
              <h1>car wash</h1>
              <h2>starting at $9.99</h2>
              <p>
                We guarantee you the best car wash experience, exceptional
                service by our professional, attentive Customer Service
                Advisors, and hyper-clean facilities.
              </p>
              <ContactUs>Contact Us</ContactUs>
            </WashText>
          </PromoWash>
          <PromoTech>
            <StaticImage src="../assets/images/tech.jpg" className="tech" />
            <TechText>
              <h2 className="techtitle">get our technician at your doorstep</h2>
              <h3>Contact -</h3>
              <h2 className="phone">555 768 654</h2>
            </TechText>
          </PromoTech>
        </PromoGrid>
      </Container>
    </PromoSection>
  );
}
